import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when location changes
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <footer className="py-12 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-center space-x-8 mb-8">
          <Link to="/" className="text-orange-500 hover:text-orange-600 font-medium transition-colors">
            Practice Dashboard
          </Link>
          <Link to="/pricing" className="text-orange-500 hover:text-orange-600 font-medium transition-colors">
            Pricing
          </Link>
          <Link to="/contact" className="text-orange-500 hover:text-orange-600 font-medium transition-colors">
            Contact Us
          </Link>
        </div>
        
        <div className="text-center">
          <p className="text-gray-600 text-sm mb-3">
            2025© All rights reserved.
          </p>
          
          {/* Subtle profile link */}
          <div className="text-center">
            <a
              href="https://www.pavlomartinovych.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-400 hover:text-gray-600 transition-colors underline"
            >
              Built by Pavlo Martinovych
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;